export const E_1 = "E-1";
export const EV2_A = "EV2-A";
export const E_TOU_B = "E-TOU-B";
export const E_TOU_C = "E-TOU-C";
export const E_TOU_D = "E-TOU-D";
export const EV_B = "EV-B";
